<template>
  <el-dialog
    title="馆人物配置信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item
        prop="advTitle"
        label="人物名称"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.advTitle"></el-input>
      </el-form-item>
      <el-form-item
              prop="type"
              label="馆分类"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.type"
                placeholder="请选择馆分类"
        >
          <el-option
                  v-for="item in ztOptions"
                  :key="item.businessid"
                  :label="item.businessname"
                  :value="item.businessid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="media_type"
              label="性别"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-radio v-model="form.media_type" label="1">男</el-radio>
        <el-radio v-model="form.media_type" label="2">女</el-radio>
      </el-form-item>
      <el-form-item
        prop="advUrl"
        label="生卒年月日"
      >

        <el-date-picker
                v-model="pickerValue"
                type="daterange"
                align="right"
                size="small"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          ></el-date-picker>
      </el-form-item>
      <el-form-item
              prop="advPos"
              label="编号"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.advPos"></el-input>
      </el-form-item>
      <el-form-item
        prop="advSort"
        label="排序"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.advSort"></el-input>
      </el-form-item>

      <el-form-item label="照片" prop="advImg"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.advImg"　 style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸1000*600像素，大小7M以内，支持jpg、png、jpeg格式
      </el-form-item>

      <el-form-item label="背景图" prop="bjImg"   :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.bjImg"　 style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileListbj"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemovebj"
                :on-success="handlePictureCardPreviewbj">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸1000*600像素，大小7M以内，支持jpg、png、jpeg格式
      </el-form-item>

      <el-form-item label="证明图" prop="swImg" >
        <el-input v-model="form.swImg"　 style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileListzm"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemovezm"
                :on-success="handlePictureCardPreviewzm">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸1000*600像素，大小7M以内，支持jpg、png、jpeg格式
      </el-form-item>

      <el-form-item   label="背景音乐" prop="advMp3" :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.advMp3"  style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="audio/mp3,image/jpg,audio/mpeg"
                :limit=1
                :auto-upload="true"
                :file-list="fileList2"
                :before-upload="handleBeforeUploadyp"
                :on-remove="handleRemoveyp"
                :on-success="handlePictureCardPreviewyp">
          <i class="el-icon-plus"></i>
          <audio controls ref="audio" v-if="mp3url !=''"　class="aud">

            <source :src="mp3url" />

          </audio>
        </el-upload>
        <div>最多可以上传1个视频，建议大小20M，推荐格式mp3</div>
      </el-form-item>
      <el-form-item
              prop="content"
              label="生平内容"
      >

        <Editor v-model="form.content"  ref="mychild"/>


      </el-form-item>


      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    import  Editor from '../notice/Editor';
export default {
  name: "smallposterEditForm",
  components: { Editor },
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    const end = new Date();
    const start = new Date();
    return {
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
      videoUrl: process.env.VUE_APP_API+"/moblieapp/videoUpload",
        formEdit: true,
      loading: false,
      TB2:false,
      TB1:true,
      pickerValue: [start, end],
      dialogVisible: false,
      videoFlag: false,
      mp3url: "",
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
        fileList: [],
      fileList2: [],
      fileListbj: [],
      fileListzm: [],
        ztOptions: [],
      form: {
        media_type:'1',
        showVideoPath: '',
        advMp3: '',
        bjImg: '',
        swImg: '',
          advImg:""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
      var formData2 = new FormData() // 声明一个FormData对象
      formData2.append('agentid',util.cookies.get('agentid'))
      agentService.getJzDispose(formData2).then(data => {
        this.ztOptions=data;
      });
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.advTitle = this.oneclass.advTitle;
          form.type = this.oneclass.type;
        　this.pickerValue=[this.oneclass.startTime,this.oneclass.endTime];
          form.advPos = this.oneclass.advPos;
          form.advSort = this.oneclass.advSort;
        if(this.oneclass.advImg!=null && this.oneclass.advImg!="") {
          form.advImg = this.oneclass.advImg;
          this.fileList = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + this.oneclass.advImg}]
        }
        if(this.oneclass.bjImg!=null && this.oneclass.bjImg!="") {
          form.bjImg = this.oneclass.bjImg;
          this.fileListbj = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + this.oneclass.bjImg}]
        }

        if(this.oneclass.swImg!=null && this.oneclass.swImg!="") {
          form.swImg = this.oneclass.swImg;
          this.fileListzm = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + this.oneclass.swImg}]
        }

        if(this.oneclass.advMp3!=null && this.oneclass.advMp3!="") {
          form.advMp3 = this.oneclass.advMp3;
          this.mp3url = "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/" + this.oneclass.advMp3;
        }

        form.media_type = this.oneclass.media_type;

        this.$refs.mychild.content="";
        this.$refs.mychild.content=this.oneclass.content;
        this.form = form;
          this.formEdit = true;
      } else {
          this.formEdit = true;
          this.fileList =[];
        this.form = {};

      }
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreviewyp(file) {
      console.log("url==="+file.url);
      this.form.advMp3 = file.url;
      this.dialogVisible = true;
    },
    changeHandler(value) {
      if(value==1){
        this.TB1=true;
        this.TB2=false;
      }else  if(value==2){
        this.TB1=false;
        this.TB2=true;
      }else{
        this.form.advUrl="文本";
        this.TB1=false;
        this.TB2=false;
      }
    },
    // 文件列表移除文件时的钩子
    handleRemoveyp(file, fileList) {
      this.form.advMp3 ="";
      this.dialogVisible = true;
    },
    // 上传文件之前的钩子
    handleBeforeUploadyp(file){
      let isJPG =true;
      // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
      console.log('before');
      if(!(file.type === 'audio/mp3' || file.type === 'audio/mpeg')) {
        isJPG=false;
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为audio/mp3, audio/mpeg的音频文件'
        })

      }
      let size = file.size / 1024 / 1024 / 1
      if(size > 20) {
        this.$notify.warning({
          title: '警告',
          message: '音频文件大小必须小于20M'
        })
        isJPG=false;
      }

      return isJPG // 返回false不会自动上传
    },
      // 上传文件之前的钩子
      handleBeforeUpload(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024 / 1
          if(size > 7) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于7M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },
      // 文件超出个数限制时的钩子
      handleExceed(files, fileList) {

      },
      // 文件列表移除文件时的钩子
      handleRemove(file, fileList) {
          this.form.advImg ="";
          this.dialogVisible = true;
      },
    // 文件列表移除文件时的钩子
    handleRemovebj(file, fileList) {
      this.form.bjImg ="";
      this.dialogVisible = true;
    },
    // 文件列表移除文件时的钩子
    handleRemovezm(file, fileList) {
      this.form.swImg ="";
      this.dialogVisible = true;
    },
    //上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 50;
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
        this.$notify.warning({
          title: '警告',
          message: '请上传正确的视频格式'
        })
        return false;
      }
      if (!fileSize) {
        this.$notify.warning({
          title: '警告',
          message: '视频大小不能超过50MB'
        })
        return false;
      }
      this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    dateConversion(value){
      var d = new Date(value);
      //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
      var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
      console.info("===========date========="+date);
      return date;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;

      //前台上传地址
      /**  if (file.status == 'success' ) {
             this.form.showVideoPath = file.url;;
          } else {
              this.$notify.warning({
                  title: '警告',
                  message: '上传失败，请重新上传'
              })
        }**/
      //后台上传地址

      if (res.code == 200) {
        alert("视频上传成功");
        //this.form.showVideoPath = "https://szqykj-1307293036.cos.ap-guangzhou.myqcloud.com/"+res.url;
        this.form.advImg=res.url;
      } else {
        this.$notify.warning({
          title: '警告',
          message: res.msg
        })
      }
    },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview(file) {
          console.log("url==="+file.url);
          this.form.advImg = file.url;
          this.dialogVisible = true;
      },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreviewbj(file) {
      console.log("url==="+file.url);
      this.form.bjImg = file.url;
      this.dialogVisible = true;
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreviewzm(file) {
      console.log("url==="+file.url);
      this.form.swImg = file.url;
      this.dialogVisible = true;
    },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
                        this.loading = true;
            agentService.saveJzDisposePoster({ ...this.form,agentid:util.cookies.get('agentid'), xt_id:util.cookies.get('xt_id'),id:this.oneclass.id,start_time: this.dateConversion(this.pickerValue[0]),end_time:this.dateConversion(this.pickerValue[1]),sh_state:'1'})
                            .then(data => {
                                this.loading = false;
                                this.dialogVisible = false;
                                this.$emit("submit");
                            });


        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

